import { postPayoutVcreditos } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '@/utils/i18n';
import { debug } from 'util';

Vue.use(Vuex);

const state = {
  payoutStatus: {
    initialize: false,
    loading: false,
    success: false,
    error: false,
  },
};

const mutations = {
  setPayoutStatus(state, row) {
    state.payoutStatus = row;
  },
};
const getters = {};
const actions = {
  tryPayout({ rootState, commit }, payload) {
    payload = {
      ...payload,
      PayoutMethod: rootState.payoutStore.selectedPayoutMethod.pk_mstpayout_method,
      PayoutAmount: rootState.payoutStore.amount,
    };
    commit('setPayoutStatus', { loading: true });
    postPayoutVcreditos(payload)
      .then(r => {
        if (r.data.IsSuccess) {
          if (r.data.Data.status && r.data.Data.status === 'OK') {
            commit('setPayoutStatus', {
              success: `Exceptions.${r.data.Data.error_code}`,
            });
          } else {
            commit('setPayoutStatus', {
              error: r.data.Data.error_code || r.data.Data.message,
            });
          }
        } else {
          commit('setPayoutStatus', { error: 'Payout.Todito.Error' });
        }
      })
      .catch(() => {
        commit('setPayoutStatus', { error: 'Payout.Todito.Error' });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
